import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';

import { AlarmTypesFailure, AlarmTypesRequest, AlarmTypesSuccess } from './actions';
import { AlarmTypesService } from './service';
import { select, Store } from '@ngrx/store';
import { AppState } from '@store/app.state';
import { getData } from './selectors';

@Injectable()
export class AlarmTypesEffects {
  private readonly actions$ = inject(Actions);
  private readonly store = inject(Store<AppState>);
  private readonly alarmTypesService = inject(AlarmTypesService);

  alarmTypes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AlarmTypesRequest),
      withLatestFrom(this.store.pipe(select(getData))),
      switchMap(([{ parameters }, data]) => {
        if (!data?.length) {
          return this.alarmTypesService.alarmTypes(parameters).pipe(
            map(data => AlarmTypesSuccess({ data })),
            catchError(error => of(AlarmTypesFailure({ error })))
          );
        }
        return of(AlarmTypesSuccess({ data }));
      })
    )
  );

}
